/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateTaskAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CreateTaskModal from './CreateTaskModal/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CreateTaskAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/CreateTaskAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let letterTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'template_id',
})
let letterRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let aggregateData = fromAggregate.and(letterTemplateIdValueData, letterRecipientIdValueData)
let letterTemplateIdValueData1 = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'template_id',
})
let letterRecipientIdValueData1 = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let aggregateData1 = fromAggregate.and(letterTemplateIdValueData1, letterRecipientIdValueData1)
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'CreateTaskModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'CreateTaskModal/Content'))}
 data="letter.template_id"
 data="letter.recipient_id"
 aggregate="/Data/aggregate.js and"
 disabled={!aggregateData}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeMm}
 weight="medium"
 text="Create Task"
 color={!aggregateData1 ? dtColorsNeutral400 : dtColorsNeutral900}
 data="letter.template_id"
 data="letter.recipient_id"
 aggregate="/Data/aggregate.js and"
/>
)}
</TysiaButton>
<CreateTaskModal
  viewPath={`${viewPath}/CreateTaskModal`}
/>
{children}
</React.Fragment>)
}